/**
 * cl-list-item-avatar
 *
 * A wrapper to apply List styles to cl-avatar.
 */

import { Component, Vue } from 'vue-property-decorator';

@Component
export default class ClListItemAvatar extends Vue {}
